const store = {
    loyaltyPointsList: () => `admin/loyalty-points/transactions`,
    loyaltyPointsItems: (id: string) => `admin/customer/${id}/loyalty-points/transactions`,
    loyaltyList: () => `admin/universal-rates`,
    loyaltyItemDetail: (id: string) => `admin/universal-rates/${id}`,
}
export default store 